import { createAction } from 'Helpers';
import questionTypes from './types';

const questionActions = {
	List_Request: createAction(questionTypes.LIST.REQUEST),
	List_Success: createAction(questionTypes.LIST.SUCCESS),
	List_Failure: createAction(questionTypes.LIST.FAILURE),
	List_Clear: createAction(questionTypes.LIST.CLEAR),

	Reply_Request: createAction(questionTypes.REPLY.REQUEST),
	Reply_Success: createAction(questionTypes.REPLY.SUCCESS),
	Reply_Failure: createAction(questionTypes.REPLY.FAILURE),
	Reply_Clear: createAction(questionTypes.REPLY.CLEAR),
};

export default questionActions;
